import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import languages from 'config/languages';

export default () => {
  const { t, i18n } = useTranslation('languages');
  const languagesList = useMemo(() => languages.map((lng) => ({ value: lng.key, label: t(lng.key) })), [languages, i18n.language]);
  return { data: languagesList };
};
